module.exports = __webpack_public_path__ + "static/media/three.3aaa58d4.jpg";